<template>
  <div>
    <el-card class="mb16">
      <table-list :show-page="false" :data="[detailInfo]">
        <el-table-column align="center" label="编号" prop="num" />
        <el-table-column align="center" label="内容" prop="content" />
        <el-table-column align="center" label="图片" >
          <template v-slot="{row}">
            <template  v-for="(pic, index) in row.photoList">
              <el-image
                  @click="$router.push('edit?code=' + row.code)"
                  v-if="index < 1"
                  :key="index"
                  :src="pic" />
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="话题" prop="topic" />
        <el-table-column align="center" label="发布者编号" prop="userNum" />
        <el-table-column align="center" label="发布者昵称" prop="username" />
        <el-table-column align="center" label="评论数" prop="baseComment" />
        <el-table-column align="center" label="点赞数" prop="baseLike" />
        <el-table-column align="center" label="发布时间" prop="createTimeStr" />
      </table-list>
    </el-card>

    <el-card>
      <template #header>
        <h4>评价展示</h4>
      </template>

      <el-form size="small" inline>
        <el-form-item label="评论者编号">
          <el-input v-model="searchForm.userNum" placeholder="评论者编号" />
        </el-form-item>
        <el-form-item label="评论者昵称">
          <el-input v-model="searchForm.username" placeholder="评论者昵称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.list.handleSearch()">查询</el-button>
          <el-button @click="$refs.list.reset()">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="btn-row">
        <el-button type="danger" size="small" @click="handleBatchDelete">批量删除</el-button>
      </div>

      <table-list
          ref="list"
          :data="tableData"
          :search-params="searchForm"
          :request-params="{dynamicsNum: $route.query.num}"
          @selection-change="selection = $event"
          @query="handleSearch">
        <el-table-column align="center" type="selection" width="50" />
        <el-table-column align="center" label="编号" prop="num" />
        <el-table-column align="center" label="评论内容" prop="content" />
        <el-table-column align="center" label="评论者编号" prop="userNum" />
        <el-table-column align="center" label="评论者昵称" prop="username" />
        <el-table-column align="center" label="点赞数" prop="likeCount" />
        <el-table-column align="center" label="评论时间" prop="createTimeStr" />
        <el-table-column align="center" label="操作">
          <template v-slot="{row}">
            <el-link :underline="false" type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </table-list>
    </el-card>

  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";

export default {
  name: "CommentList",
  components: {TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      detailInfo: []
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.dynamicsComment.delete, {code: row.code});
        this.$message.success("操作成功")
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning("请选择要删除的数据");
          return;
        }
        await requestByTip(
            this.$api.dynamicsComment.batchDelete,
            codes,
            {isJson: true},
            {message: "您现在正在进行批量删除操作, 是否继续?"}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        params.commentNum = "null"; // 不显示二级评论
        let res = await request(this.$api.dynamicsComment.list, params);
        this.tableData = res.dynamicsComments.map(item => {
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        })
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    async loadDetail() {
      try {
        const code = this.$route.query.code;
        const res = await request(this.$api.dynamics.detail, {code});
        this.detailInfo = res.dynamics;
        this.detailInfo.createTimeStr = this.$moment(res.dynamics.createTime).format("YYYY-MM-DD HH:mm:ss");
        const photoList = res.dynamics.photo ? res.dynamics.photo.split(",") : [];
        this.detailInfo.photoList = photoList.map(i => this.$api.file.downloadImg + i);
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.btn-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}


</style>
